<script>
    import { fade } from "svelte/transition";

    export let show = false;
    export let title = "No Title";
    export let modalId = "default-modal";
    export let modalBodyEl = null;
    export let modalFooterEl = "";

    let modalBody;
    let modalFooter;
    function closeModal() {
        show = false;
    }

    $: {
        if (modalBody && modalBodyEl) {
            modalBody.innerHTML = "";
            modalBody.appendChild(modalBodyEl);
        }

        if (modalFooter && modalFooterEl) {
            modalFooter.innerHTML = "";
            modalFooter.appendChild(modalFooterEl);
        }
    }
</script>

{#if show}
    <div
        class="modal fade show d-block"
        id={modalId}
        tabindex="-1"
        role="dialog"
        aria-labelledby="{modalId}Label"
        transition:fade={{ duration: 150 }}
        style="display: block;"
    >
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="{modalId}Label">{title}</h5>
                    <button type="button" class="btn-close" aria-label="Close" on:click={closeModal}></button>
                </div>
                <div class="modal-body" bind:this={modalBody}></div>
                <div class="modal-footer">
                    <div class="modal-foter-content" bind:this={modalFooter}></div>
                    <button type="button" class="btn btn-secondary" on:click={closeModal}>Close</button>
                </div>
            </div>
        </div>
    </div>
{/if}

<style>
    :global(body.modal-open) {
        overflow: hidden;
    }

    .modal {
        background-color: rgba(0, 0, 0, 0.5);
        overflow-y: auto;
    }

    .modal-content {
        border-radius: var(--bs-border-radius);
        box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
    }
</style>
